export default "__VITE_ASSET__9ac4e147__"